import { useContext, useEffect } from 'react';
import { AppContext } from '../../../main/context/Provider';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { ProjectStatusForm } from '../components/form/ProjectStatusForm';

export const CreateProjectStatusPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Nuevo Estado ');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Estados',
                route: Private_Routes.PROJECT_STATUS_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.CREATE_PROJECT_STATUS,
            },
        ]);
    }, [lang]);

    return <ProjectStatusForm isNewProjectStatus={true} />;
};
